'use client'

import { useTranslations } from 'next-intl'

import ModalCloseIcon from '@/assets/icons/modal-close.svg'
import { useAuth } from '@/providers/AuthProvider'
import Dialog from '@/ui/Dialog'

import S from './TasksSignUpDialog.module.scss'

type TasksSignUpDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function TasksSignUpDialog({
  open,
  onOpenChange
}: TasksSignUpDialogProps) {
  const t = useTranslations('tasksPage.accessDialogs.signUp')
  const { openAuthModal } = useAuth()

  const handleCreateAccount = () => {
    onOpenChange(false)
    openAuthModal('login', 'tasks_list')
  }

  return (
    <Dialog
      open={open}
      toggle={onOpenChange}
      description={t('description')}
      className={S.dialog}
      withoutClose
    >
      <div className={S.inner}>
        <button
          type="button"
          className={S.cornerClose}
          aria-label={t('closeAria')}
          onClick={() => onOpenChange(false)}
        >
          <ModalCloseIcon className={S.cornerIcon} aria-hidden />
        </button>

        <h2 className={S.title}>{t('title')}</h2>
        <p className={S.description}>
          <span className={S.descriptionLine}>{t('descriptionLine1')}</span>
          <span className={S.descriptionLine}>{t('descriptionLine2')}</span>
        </p>

        <button
          type="button"
          className={S.primaryBtn}
          onClick={handleCreateAccount}
        >
          {t('createAccount')}
        </button>
      </div>
    </Dialog>
  )
}
